import { DirectMessageBaseClass } from '../DirectMessageBase';
import { Message } from '../DirectMessagesImport';
export class OTTResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_OTT_RESPONSE);
    }
}
